<template>
  <NuxtLink
    class="group relative block rounded-[32px] no-underline lg:rounded-[40px]"
    :to="localePathByType(data.link?.__typename as string, data.link?.slug as string)"
    :class="[
      data.style === STYLES.LARGE && 'text-white lg:h-[640px]',
      data.style === STYLES.MEDIUM && 'text-white lg:h-[304px]',
      data.style === STYLES.SMALL && 'flex border border-neutral-800 text-neutral-800 lg:h-[304px]'
    ]"
  >
    <div
      class="overflow-hidden rounded-[32px] lg:rounded-[40px]"
      :class="
        data.style === STYLES.SMALL
          ? 'w-full min-w-[180px] max-w-xs basis-[40%] lg:min-w-[304px]'
          : 'absolute top-0 h-full w-full'
      "
    >
      <Image
        class="rounded-[32px] object-cover !transition-all !duration-300 group-hover:scale-110 lg:rounded-[40px]"
        :class="
          data.style !== STYLES.SMALL
            ? 'h-full w-full'
            : '-ml-[1px] -mt-[1px] h-[calc(100%+2px)] w-[calc(100%+2px)]'
        "
        loading="lazy"
        :sizes="data.background.responsiveImage?.sizes"
        :src="
          data.background.responsiveImage
            ? data.background.responsiveImage?.src
            : data.background.url
        "
        :srcset="
          data.background.responsiveImage ? data.background.responsiveImage?.webpSrcSet : undefined
        "
        :width="
          data.background.responsiveImage
            ? data.background.responsiveImage.width
            : data.background.width
        "
        :height="
          data.background.responsiveImage
            ? data.background.responsiveImage.height
            : data.background.height
        "
        :alt="data.background.alt ? data.media.alt : ''"
      />
    </div>

    <div
      class="relative z-2 p-6 lg:p-8"
      :class="[
        data.style === STYLES.LARGE && 'flex flex-col justify-between gap-32 md:gap-80',
        data.style === STYLES.MEDIUM && 'flex flex-col justify-between gap-16 md:gap-20',
        data.style === STYLES.SMALL &&
          'flex basis-[60%] items-center justify-center lg:min-h-[304px]'
      ]"
    >
      <div
        v-if="data.style !== STYLES.SMALL"
        class="flex h-12 w-12 items-center justify-center rounded-full bg-white lg:h-16 lg:w-16"
      >
        <Icon name="polygon" :color="theme.colors.neutral[900]" size="sm" />
      </div>
      <div>
        <div
          class="mb-3 w-fit rounded-lg p-2 text-sm uppercase"
          :class="
            data.style === STYLES.SMALL
              ? 'hidden bg-neutral-800 text-white lg:block'
              : 'bg-white text-neutral-800'
          "
        >
          {{ data.tag }}
        </div>
        <div
          class="line-clamp-3"
          :class="[
            data.style === STYLES.LARGE && 'text-xl lg:text-4xl',
            data.style === STYLES.MEDIUM && 'text-lg lg:text-3xl',
            data.style === STYLES.SMALL && 'text-lg lg:text-3xl'
          ]"
        >
          {{ data.title }}
        </div>
      </div>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import { theme } from '#tailwind-config'

const { localePathByType } = useLocalePathByType()

enum STYLES {
  LARGE = 'Large',
  MEDIUM = 'Medium',
  SMALL = 'Small'
}

defineProps({
  data: {
    type: Object,
    default: () => {}
  }
})
</script>
